import { OverlayArrow as AriaOverlayArrow } from 'react-aria-components';

export const OverlayArrow = AriaOverlayArrow;
